import {BehaviorSubject} from 'rxjs';
import {filter, map, startWith, shareReplay, distinctUntilChanged} from 'rxjs/operators';
import {wwData$} from './worker-data';
import Msg = ww.Msg;
import BookData = ww.BookData;

const initialBook = createInitBook();

export const bookTickSizeEp$ = new BehaviorSubject(0);

export const book$ = wwData$.pipe(
  filter((o: Msg<BookData>) => o.type === 'orderbook'),
  map((o: Msg<BookData>) => o.data.book),
  startWith<Book>(initialBook),
  distinctUntilChanged(),
  shareReplay(1)
);

// 固定30个tick的book,用于计算百分比与逻辑判断，book$数据用户可通过视图控制数据返回，有可能为空
export const fixationBook$ = wwData$.pipe(
  filter((o: Msg<BookData>) => o.type === 'fixation-order-book'),
  map((o: Msg<BookData>) => o.data.book),
  startWith<Book>(initialBook),
  distinctUntilChanged(),
  shareReplay(1)
);

function createInitBook(): Book {
  return {
    bids: [],
    asks: [],
    bid1Ep: 0,
    ask1Ep: 0,
  };
}
